import { Reveal } from "@/components/site/Reveal";
import { Home, Clock, HeartPulse, Sparkles } from "lucide-react";

const WHO = [
  { icon: Home, label: "Work from home" },
  { icon: Clock, label: "Limited time" },
  { icon: HeartPulse, label: "Afraid of gyms" },
  { icon: Sparkles, label: "Don't know where to start" },
];

export const WhoFor = () => (
  <section className="py-16 md:py-20 bg-[#020617] border-b border-white/10">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="font-mono-label text-[11px] text-[#94A3B8] mb-8">Made for people who —</p>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {WHO.map((w, i) => {
          const Icon = w.icon;
          return (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`whofor-${i}`}
                className="flex items-center gap-3 p-5 rounded-2xl border border-white/10 hover:border-[#FACC15]/50 transition-colors duration-300"
              >
                <Icon size={22} className="text-[#FACC15] shrink-0" />
                <span className="font-display text-base md:text-xl">{w.label}</span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
